import React from 'react';
import { Messages } from '../../codegen/Localize';
import { EmailAndDisplayNameForm } from './EmailAndDisplayNameForm';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { LanguageForm, LanguageFormProps, LanguageFormFields } from './LanguageForm';
import { LocaleFormProps, LocaleForm, LocaleFormFields } from './LocaleForm';
import { TimeZoneFormFields, TimeZoneForm, TimeZoneFormProps } from './TimeZoneForm';
import { UserSettingsHelper } from '../UserSettingsHelper';

export interface LanguageAndRegionSettingsProps {
  //data
  languageInitialValues: LanguageFormFields;
  localeInitialValues: LocaleFormFields;
  timeZoneInitialValues: TimeZoneFormFields;
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isServerUserSubplace?: boolean;
}

export function LanguageAndRegionSettings({languageInitialValues, localeInitialValues, timeZoneInitialValues, ...passThroughProps}: LanguageAndRegionSettingsProps) {
  const languageProps: LanguageFormProps = {
    initialValues: languageInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const localeProps: LocaleFormProps = {
    initialValues: localeInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const timeZoneProps: TimeZoneFormProps = {
    initialValues: timeZoneInitialValues,
    serverUser: passThroughProps.serverUser
  };
  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_LanguageAndRegion_Header()}</h2>
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.tbodyNew} colSpan={3}>
            <LanguageForm {...languageProps}/>
            <LocaleForm {...localeProps}/>
          </td>
        </tr>
        {!passThroughProps.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        {!passThroughProps.isServerUserSubplace &&
        <tr>
          <td className={UserSettingsStyle.tbodyNew} colSpan={3}>
            <TimeZoneForm {...timeZoneProps} />
          </td>
        </tr>}
      </tbody>
    </table>
    </>
  );
}